const SpecificationsTable = ({ specificationArray }) => (
  <table className="velorbis-customizer-specifications-table">
    <thead>
      <tr>
        <th>Component</th>
        <th>Selection</th>
        <th>Specifications</th>
      </tr>
    </thead>
    <tbody>
      {specificationArray &&
        specificationArray.map((bikePart, index) => (
          <tr key={index}>
            <td>{bikePart[0]}</td>
            <td>{bikePart[1]}</td>
            <td>{bikePart[2]}</td>
          </tr>
        ))}
    </tbody>
  </table>
)

export default SpecificationsTable
